import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	importInProgress: {
		id: 'project-create-import-progress.import-progress-bar.import-in-progress',
		defaultMessage: 'Import in progress',
		description: 'Heading for the import in progress bar displayed next to the project header',
	},
	importComplete: {
		id: 'project-create-import-progress.import-progress-bar.import-complete',
		defaultMessage: '\u2728 Import complete \u2728',
		description:
			'Heading for the import complete progress bar displayed next to the project header',
	},
});
